import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const LogoutIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="LogoutIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/logout">
            <g id="Vector">
                <path
                    d="M9.64746 2.47109C10.2969 2.2416 10.9779 2.72152 10.9805 3.40957H13.8955C14.7238 3.40957 15.3954 4.08126 15.3955 4.90957V7.95449C15.3954 8.23052 15.1716 8.45449 14.8955 8.45449C14.6194 8.45449 14.3956 8.23052 14.3955 7.95449V4.90957C14.3954 4.63355 14.1716 4.40957 13.8955 4.40957H10.9805V19.5883H13.8955C14.1716 19.5883 14.3955 19.3644 14.3955 19.0883V16.0434C14.3958 15.7675 14.6195 15.5434 14.8955 15.5434C15.1715 15.5434 15.3952 15.7675 15.3955 16.0434V19.0883C15.3955 19.9167 14.7239 20.5883 13.8955 20.5883H10.9805C10.9786 21.2768 10.2972 21.7581 9.64746 21.5287L4.40039 19.6752C4.00051 19.534 3.73321 19.1559 3.7334 18.7318L3.74512 5.26406C3.74551 4.84063 4.0129 4.46284 4.41211 4.32168L9.64746 2.47109Z"
                    fill="currentColor"
                >
                </path>
                <path
                    d="M16.2314 8.46914C16.4267 8.27405 16.7432 8.27405 16.9385 8.46914L20.1201 11.6508C20.3153 11.846 20.3152 12.1625 20.1201 12.3578L16.9385 15.5395C16.7432 15.7347 16.4267 15.7347 16.2314 15.5395C16.0363 15.3442 16.0362 15.0276 16.2314 14.8324L18.5596 12.5043H12.7607C12.4846 12.5043 12.2607 12.2804 12.2607 12.0043C12.2609 11.7283 12.4847 11.5043 12.7607 11.5043H18.5596L16.2314 9.17617C16.0363 8.9809 16.0362 8.66436 16.2314 8.46914Z"
                    fill="currentColor"
                >
                </path>
            </g>
        </g>
    </SvgIcon>
)
